import { Service } from '@angular/core';
import { AbstractSearchService } from './abstract-search.service';
import { SearchChannel } from './search.channels';

@Service()
export class SearchService extends AbstractSearchService<SearchChannel> {}
